import React from 'react'
import T from 'prop-types'
import { Grid } from '@mui/material'

export default function CarsList({ left, right }) {
  return (
    <Grid
      container
      columnSpacing={3}
      rowSpacing={2}
      sx={{ mt: 0 }}
      data-testid="cars-list"
    >
      <Grid item xs={3} data-testid="cars-list-left-column">
        {left}
      </Grid>
      <Grid item xs={9} data-testid="cars-list-right-column">
        {right}
      </Grid>
    </Grid>
  )
}

CarsList.propTypes = {
  left: T.node.isRequired,
  right: T.node.isRequired,
}
